export function getLettereAvatar(user) {
    let lettere = '';
    if (user && user.nome && user.nome !== '') {
        lettere += user.nome[0]
    }
    if (user && user.cognome && user.cognome !== '') {
        lettere += user.cognome[0]
    }
    return lettere;
}

const hRange = [0, 30];
const sRange = [70, 100];
const lRange = [0, 60];

export const generateHSL = (name) => {
    const hash = getHashOfString(name);
    const h = normalizeHash(hash, hRange[0], hRange[1]);
    const s = normalizeHash(hash, sRange[0], sRange[1]);
    const l = normalizeHash(hash, lRange[0], lRange[1]);
    return `hsl(${h}, ${s}%, ${l}%)`;
};

const getHashOfString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return hash;
};

const normalizeHash = (hash, min, max) => {
    return Math.floor((hash % (max - min)) + min);
};